
import { Injectable } from '@angular/core';
import { UrlsService } from './urls.service';
import { UserService } from './user.service';
import { SharedHttpClientService } from './shared-http-client.service';
import { camelCase } from 'lodash';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { ConstantService } from 'app/Shared/Services/constant-service';
import {default as CAT_MECO} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MECO.json';
import {default as CAT_MECOC} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MECOC.json';
import {default as CAT_MECOM} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MECOM.json';
import {default as CAT_MEFA} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEFA.json';
import {default as CAT_MEIR} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEIR.json';
import {default as CAT_MENO} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MENO.json';
import {default as CAT_MENOS} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MENOS.json';
import {default as CAT_MENQ} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MENQ.json';
import {default as CAT_MEOA} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEOA.json';
import {default as CAT_MEOC} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEOC.json';
import {default as CAT_MEOF} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEOF.json';
import {default as CAT_MEOJ }from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEOJ.json';
import {default as CAT_MEOM } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEOM.json';
import {default as CAT_MEOMS}  from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEOMS.json';
import {default as CAT_MEOR } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEOR.json';
import {default as CAT_MEOT } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEOT.json';
import {default as CAT_MEOTS}  from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEOTS.json';
import {default as CAT_MEQC } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEQC.json';
import {default as CAT_MEQN } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEQN.json';
import {default as CAT_MEQR } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEQR.json';
import {default as CAT_MERQ } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MERQ.json';
import {default as CAT_MEAA } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEAA.json';
import {default as CAT_MEIC }from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEIC.json';
import {default as CAT_MEIM }from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEIM.json';
import {default as CAT_MEOE }from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEOE.json';
import {default as CAT_MEOFS} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEOFS.json';
import {default as CAT_MEORS} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEORS.json';
import {default as CAT_MEPA }from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEPA.json';
import {default as CAT_MOCO }from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MOCO.json';
import {default as CAT_MOCOC} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MOCOC.json';
import {default as CAT_MOCOM} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MOCOM.json';
import {default as CAT_MOFA }from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MOFA.json';
import {default as CAT_MOPA }from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MOPA.json';
import {default as CAT_MOAA }from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MOAA.json';
import {default as CAT_MOIR }from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MOIR.json';
import {default as CAT_MONO }from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MONO.json';
import {default as CAT_MONOS} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MONOS.json';
import {default as CAT_MONQ } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MONQ.json';
import {default as CAT_MOOA } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MOOA.json';
import {default as CAT_MOOC } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MOOC.json';
import {default as CAT_MOOF } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MOOF.json';
import {default as CAT_MOOFS}  from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MOOFS.json';
import {default as CAT_MOOJ } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MOOJ.json';
import {default as CAT_MOOM } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MOOM.json';
import {default as CAT_MOOR } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MOOR.json';
import {default as CAT_MOMR } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MOMR.json';
import {default as CAT_MOCR } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MOCR.json';
import {default as CAT_MOOE } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MOOE.json';
import {default as CAT_MOOT } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MOOT.json';
import {default as CAT_MOORS}  from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MOORS.json';
import {default as CAT_MOIM } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MOIM.json';
import {default as CAT_MOIC } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MOIC.json';
import {default as CAT_MOQR } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MOQR.json';
import {default as CAT_MORQ } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MORQ.json';
import {default as CAT_MOIMR}  from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MOIMR.json';
import {default as CAT_MOICR} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MOICR.json';
import {default as CAT_MOOMS} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MOOMS.json';
import {default as CAT_MOOMR} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MOOMR.json';
import {default as CAT_MOOCR} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MOOCR.json';
import {default as CAT_MOMRS} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MOMRS.json';
import {default as CAT_MOCRS} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MOCRS.json';
import {default as CAT_MEMR }from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEMR.json';
import {default as CAT_MECR }from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MECR.json';
import {default as CAT_MEIMR} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEIMR.json';
import {default as CAT_MEICR} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEICR.json';
import {default as CAT_MEOMR} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEOMR.json';
import {default as CAT_MEOCR} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEOCR.json';
import {default as CAT_MEMRS} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEMRS.json';
import {default as CAT_MECRS} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MECRS.json';
import {default as CAT_MLNO }from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MLNO.json';
import {default as CAT_MLNQ }from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MLNQ.json';
import {default as CAT_MLOR }from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MLOR.json';
import {default as CAT_MLMR }from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MLMR.json';
import {default as CAT_MLCR } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MLCR.json';
import {default as CAT_MLOA } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MLOA.json';
import {default as CAT_MLIR } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MLIR.json';
import {default as CAT_MLIM } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MLIM.json';
import {default as CAT_MLIC } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MLIC.json';
import {default as CAT_MLIMR}  from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MLIMR.json';
import {default as CAT_MLICR}  from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MLICR.json';
import {default as CAT_MLCO } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MLCO.json';
import {default as CAT_MLCOM}  from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MLCOM.json';
import {default as CAT_MLCOC}  from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MLCOC.json';
import {default as CAT_MLOM } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MLOM.json';
import {default as CAT_MLOMR}  from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MLOMR.json';
import {default as CAT_MLOC } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MLOC.json';
import {default as CAT_MLOCR}  from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MLOCR.json';
import {default as CAT_MLOS } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MLOS.json';
import {default as CAT_MLQR } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MLQR.json';
import {default as CAT_MLRQ } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MLRQ.json';
import {default as CAT_MLOE } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MLRQ.json';
import { map } from 'rxjs/internal/operators/map';
import $ from 'jquery';

@Injectable(
    {providedIn: 'root'}
)
export class GridService {
    private Dataset: any = [];
    private SymbolsArray: any = [];
    public eventTypes: any = [];
    private recordcount: any;
    public multiDimensionalColumns: any;
    Symbols: any = [];
    rowcount: number | any = 0;
    columnArr:any=[];


    constructor(private datePipe: DatePipe,
        private UrlsService: UrlsService,
        private UserService: UserService,
        private router: Router,
        private SharedHttpClientService: SharedHttpClientService,
        private ConstantService: ConstantService) {
        this.eventTypes = this.ConstantService.FilterEventTypes;
        this.multiDimensionalColumns = this.ConstantService.ExportablemultiDimensinalColumns;
    }
    scrollToTop() {
       // window.scrollTo(0, 0);
    }

    getGridRowsCount() {
        this.scrollToTop();
        this.rowcount = $(window).innerHeight();
        this.rowcount = Math.round((this.rowcount - 300) / 22);
        if (this.rowcount <= 15)
            this.rowcount = 15;
        return this.rowcount;
    }
    addFilterRow() {
        return {
            'isdefault': 'false',
            'label': 'Select Column',
            'columnname': 'Select Column',
            'filterby': 'Select Filter',
            'values': 'Enter Value',
            'time': 'Select Time',
            "datatype": '',
            'disabled': 'false',
            'dropdown': '',
            'dropdownvalue': ''
        }

    }

    setFilterArray(FilterArray: any, Data: any, GridColumns: any) {
        let DefaultFilterArray: any = [];
        let rowObj = Data;
        let dateRange: any[] = [];
        if (rowObj != null || FilterArray != null || GridColumns != undefined) {
            dateRange[0] = this.datePipe.transform(rowObj['dateRange'], "yyyy-MM-dd");
            dateRange[1] = this.datePipe.transform(rowObj['dateRange'], "yyyy-MM-dd");

            for (let j = 0; j < FilterArray.length; j++) {
                let FilterArrayObj = FilterArray[j];
                let filterby = FilterArrayObj.filterby
                let values: any = "";
                let datatype: any = FilterArrayObj.datatype;
                let GridColumnindex: number = 0;
                if (FilterArrayObj.mappingkey) {

                    GridColumnindex = GridColumns.findIndex(function (item: any, i: any) {
                        return (item.mappingkey).toLowerCase() == (FilterArrayObj.mappingkey).toLowerCase();
                    });
                    if (GridColumnindex >= 0) {
                        values = (FilterArrayObj.mappingkey).toLowerCase() == 'daterange' ? dateRange : rowObj[FilterArrayObj.mappingkey];
                    }
                    if (datatype.toLowerCase() == 'string' || datatype.toLowerCase() == 'char') {
                        values = String(values);
                    }
                }
                DefaultFilterArray[j] =
                {
                    "isdefault": "true",
                    "label": FilterArrayObj.label,
                    "columnname": GridColumnindex >= 0 ? GridColumns[GridColumnindex].db_columnname : FilterArrayObj.columnname,
                    "filterby": filterby,
                    "values": values,
                    "time": "",
                    "datatype": GridColumnindex >= 0 ? GridColumns[GridColumnindex].datatype : FilterArrayObj.datatype,
                    "disabled": false,
                };
            }
            return DefaultFilterArray;
        }
    }

    getApplicationFilterQueries(payloadData: any, ApplicationURL: any) {
        return this.SharedHttpClientService.post(this.UrlsService.setAPIURl(ApplicationURL), payloadData)
        .pipe(map((response: Response) => {
            return response;
        }));
    }

    deleteApplicationFilterQuery(payloadData: any, ApplicationURL: any) {
        return this.SharedHttpClientService.post(this.UrlsService.setAPIURl(ApplicationURL), payloadData);
    }

    prepareData(url: any, filterArray: any, limit: any, pageName: any, tableName?: any) {
        /* ** set post dataset */
        if (limit.End == 0 && limit.End == '' && limit.Start == '') {
            this.getGridRowsCount();
            limit.End = this.rowcount;
            limit.Start = 0;
        }
        const filterData = JSON.parse(JSON.stringify(filterArray));
        if (this.router.url.indexOf('Error-Codes') === -1) {
            filterData[0].values[0] = this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
            filterData[0].values[1] = this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));
        }
        let transactionFilter  = filterArray.find((f:any)=>f.columnname === 'transaction');
        let orderConditionFilter = filterArray.find((f:any)=>f.columnname === 'orderCondition');
        let Data: any;
        if (pageName === 'ODR_CAT_Comparison') {
            const comparisonFilterArray = filterArray.filter((filter: any) => filter.columnname === 'reportDate');
            const comparisonFilter = JSON.parse(JSON.stringify(comparisonFilterArray))
            if (this.router.url.indexOf('Error-Codes') === -1) {
                comparisonFilter[0].values[0] = this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(comparisonFilter[0].values[0])));
                comparisonFilter[0].values[1] = this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(comparisonFilter[0].values[1])));
            }
            Data = {
                "data": comparisonFilter,
                "mpid": this.UserService.getActiveMPID(),
                'pageName': pageName,
            };
        }
        else {  
         Data = {
            "data": filterData,
            "mpid": this.UserService.getActiveMPID(),
            "startLimit": limit.Start + "",
            'endLimit': limit.End + "",
            'pageName': pageName,
            'eventType': "",
            'transaction':transactionFilter?.values,
            'orderCondition':Array.isArray(orderConditionFilter?.values) ? orderConditionFilter?.values : [],
        };
    }
        
        if (tableName) {
              Data.tableName = tableName
        }
        return this.SharedHttpClientService.post(this.UrlsService.setAPIURl(url), Data)
            .pipe(map((response: Response) => {
                return response;
            }));
    }

    getUserList() {
        return this.SharedHttpClientService.post(
            this.UrlsService.setAPIURl(
                APIURL.Exception_User_List
            ), {
            mpid: this.UserService.getActiveMPID()
        })
    }

    getData(url: any, FilterArray: any, limit: any, eventtype: any, pageName: any, exceptionId?: number, tableName?: any) {
        /* ** set post dataset */
        if (limit.End == 0 && limit.End == '' && limit.Start == '') {
            this.getGridRowsCount();
            limit.End = this.rowcount;
            limit.Start = 0;
        }
        const filterData = JSON.parse(JSON.stringify(FilterArray));
        if (this.router.url.indexOf('FDID') === -1 && this.router.url.indexOf('LTID') === -1 && this.router.url.indexOf('Customer-Info') === -1) {
            filterData[0].values[0] = this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
            filterData[0].values[1] = this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));
        }
        
        let transactionFilter  = FilterArray.find((f:any)=>f.columnname === 'transaction');
        let orderConditionFilter = FilterArray.find((f:any)=>f.columnname === 'orderCondition');

        let Data: any = {
            "data": filterData,
            "mpid": this.UserService.getActiveMPID(),
            "startLimit": limit.Start + "",
            'endLimit': limit.End + "",
            'pageName': pageName,
            'eventType': eventtype,
            'transaction':transactionFilter?.values,
            'orderCondition':Array.isArray(orderConditionFilter?.values) ? orderConditionFilter?.values : [],
        };
        if (exceptionId) {
            Object.assign({ 'exceptionId': exceptionId });
        }
        if (tableName) {
            Data.tableName = tableName
        }
        return this.SharedHttpClientService.post(this.UrlsService.setAPIURl(url), Data)
            .pipe(map((response: Response) => {
                return response;
            }));
    }
    getOrderIDList(url: any, fromdate: any, todate: any, orderID: any, symbol: any, pageName: any) {
        let Data = {
            "mpid": this.UserService.getActiveMPID(),
            "fromdate": fromdate,
            "todate": todate,
            "orderID": orderID,
            "symbol": symbol,
            'pageName': pageName
        };
        return this.SharedHttpClientService.post(this.UrlsService.setAPIURl(url), Data)
            .pipe(map((response: Response) => {
                return response;
            }));
    }

    getExcludeFilter(defaultFilter: any) {
        let excludeFilter: string[] = [];
        if (defaultFilter != null || defaultFilter != undefined) {
            for (let i = 0; i < Object.keys(defaultFilter).length; i++) {
                excludeFilter[i] = defaultFilter[i]?.columnname.toLowerCase();
            }
        }
        return excludeFilter;
    }


    getGridColumnsWithExclude(column: any, excludeFilter: string[]) {
        this.scrollToTop();
        let cols: any = [];
        let j = 0;
        if (column != null || column != undefined) {
            for (let i = 0; i < Object.keys(column).length; i++) {
                if (excludeFilter.indexOf(column[i]?.db_columnname.toLowerCase()) === -1) {
                    cols[j] =
                    {
                        header: column[i]?.ui_columnname,
                        field: (column[i]?.mappingkey),
                        datatype: column[i]?.datatype,
                        label: column[i]?.ui_columnname,
                        value: column[i]?.db_columnname,
                        display: column[i]?.display,
                        time: "00:00:00"
                    }
                    j++;
                }
            }
        }
        return cols;
    }

    getGridColumns(column: any) {
        this.scrollToTop();
        let cols: any = [];
        if (column != null || column != undefined) {
            for (let i = 0; i < Object.keys(column).length; i++) {

                cols[i] =
                {
                    header: column[i]?.ui_columnname,
                    field: (column[i]?.mappingkey),
                    datatype: column[i]?.datatype,
                    label: column[i]?.ui_columnname,
                    value: column[i]?.db_columnname,
                    db_columnname: column[i]?.db_columnname,
                    display: column[i]?.display,
                    disabled:  column[i]?.disabled,
                    dropdown:  column[i]?.dropdown,
                    dropdowntype:  column[i]?.dropdowntype,
                    dropdownvalue:  column[i]?.dropdownvalue,
                    maxlength:  column[i]?.maxlength,
                    time: "00:00:00",
                    count: column[i]?.count,
                    isoptionalfields: column[i]?.isOptionalFields
                }

            }
        }
        return cols;
    }

    getGridColumnsOftree(column: any) {
        this.scrollToTop();
        let cols: any = [];
        if (column != null || column != undefined) {
            for (let i = 0; i < Object.keys(column).length; i++) {

                cols[i] =
                {
                    header: column[i]?.ui_columnname,
                    field: (column[i]?.mappingkey),
                    datatype: column[i]?.datatype,
                    label: column[i]?.ui_columnname,
                    value: column[i]?.db_columnname,
                    display: column[i]?.display,
                    width: column[i]?.width,
                    time: "00:00:00"
                }

            }
        }
        return cols;
    }

    getGridColumnsHandlingInsrtuction(column: any) {
        this.scrollToTop();
        let cols: any = [];
        for (let i = 0; i < column.length; i++) {
            cols[i] = {
                header: column[i].ui_columnname,
                field: (column[i].mappingkey),
            }
        }

        return cols;
    }
    getGridColumnsHasValues(column: any) {
        this.scrollToTop();
        let cols: any = [];
        for (let i = 0; i < column.length; i++) {
            cols[i] = {
                header: column[i][0],
                field: column[i][0],
            }
        }

        return cols;
    }
    getDefault(column: any) {
        let cols: any = [];
        if (column != null || column != undefined) {
            for (let i = 0; i < Object.keys(column).length; i++) {
                cols[i] =
                {
                    header: column[i].ui_columnname,
                    field: (column[i].mappingkey),
                    datatype: column[i].datatype,
                    label: column[i].ui_columnname,
                    value: column[i].db_columnname,
                    display: column[i].display,
                    time: "00:00:00"
                }
            }
        }
        return cols;
    }

    getSymbol(url: any, FilterArray: any, limit: any, pageName: any) {
        const filterData = JSON.parse(JSON.stringify(FilterArray));
        if(filterData[0].values.length === 2) {
            filterData[0].values[0] = this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
            filterData[0].values[1] = this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));
        }
        let Data = { "data": filterData, "mpid": this.UserService.getActiveMPID(), "startLimit": pageName === 'Front-Running' ? limit.Start : 0, 'endLimit': pageName === 'Front-Running' ? limit.End : 0, 'pageName': pageName };
        return this.SharedHttpClientService.post(this.UrlsService.setAPIURl(url), Data)
            .pipe(map((response: Response) => {
                return response;
            }));
    }
    getEventsList(DefaultFilterArray: any, KeyName: any) {
        let indexForEventTypeValue = DefaultFilterArray.findIndex(function (item: any, i: any) {
            return item.label === KeyName
        });
        let EventValue: any;
        let Events: string = "";
        if (indexForEventTypeValue > 0) {
            EventValue = DefaultFilterArray[indexForEventTypeValue];
            let EventValues: any = [];
            if (EventValue) {
                if (EventValue.values == "" || EventValue.values == " ") {
                    let DropdownvalueArray: any = EventValue.dropdownvalue;
                    if (DropdownvalueArray != undefined && DropdownvalueArray != null && DropdownvalueArray) {
                        for (let i = 0; i < DropdownvalueArray.length; i++) {
                            if (DropdownvalueArray[i].isActive == true)
                                EventValues.push(DropdownvalueArray[i].value)
                        }
                    }

                    EventValue.values = EventValues;
                }

                let EventsArray: any = EventValue.values;
                for (let i = 0; i < EventsArray.length; i++) {
                    Events = Events + "'" + EventsArray[i] + "'";
                    if (i != EventsArray.length - 1) {
                        Events = Events + ",";
                    }
                }
            }
        }
        return Events;
    }
    public camelizeKeys = (obj: { [x: string]: string | undefined; map?: any; constructor?: any; } | null) => {
        if (Array.isArray(obj)) {
            return obj.map((v: { [x: string]: string | undefined; map?: any; constructor?: any; } | null) => this.camelizeKeys(v));
        } else if (obj !== null && obj.constructor === Object) {
            return Object.keys(obj).reduce(
                (result, key) => ({
                    ...result,
                    [key]: camelCase(obj[key]),
                }),
                {},
            );
        }
        return obj;
    };
    public camelCase(str: string) {
        return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
            return index == 0 ? word.toLowerCase() : word.toUpperCase();
        }).replace(/\s+/g, '');

    }
    ConvertKeysToLowerCase(obj: any) {
        let output: any = {};
        for (let i in obj) {
            if (Object.prototype.toString.apply(obj[i]) === '[object Object]') {
                output[i.toLowerCase()] = this.ConvertKeysToLowerCase(obj[i]);
            } else if (Object.prototype.toString.apply(obj[i]) === '[object Array]') {
                output[i.toLowerCase()] = [];
                output[i.toLowerCase()].push(this.ConvertKeysToLowerCase(obj[i][0]));
            } else {
                output[i.toLowerCase()] = obj[i];
            }
        }
        return output;
    };

    toLowerCaseKeys(InpputArray: any) {
        let key, keys = Object.keys(InpputArray);
        let outputArray: any = []
        let n = keys.length;
        let newobj: any;
        while (n--) {
            key = keys[n];
            newobj[key.toLocaleLowerCase()] = InpputArray[key];
        }
        outputArray.push(JSON.stringify(newobj))
        return outputArray;
    }

    //**Filtering Symbols */
    prepareSymbols(json: any) {
        let temp = json;
        // Store each of the elements in an object keyed of of the name field.  If there is a collision (the name already exists) then it is just replaced with the most recent one.
        // for (var i = 0; i < json.length; i++) {
        //     temp[json[i].symbol] = json[i];
        // }
        // Reset the array in varjson
        this.Symbols = [];
        // Push each of the values back into the array.
        for (let o in temp) {
            this.Symbols.push({ "label": temp[o].symbol });
        }
        this.Symbols.sort((x: any, y: any) => ((x.label == y.label) ? 0 : ((x.label > y.label) ? 1 : -1)));
        /* this.Symbols.sort(function (a, b) {
            var textA = a.label.toUpperCase();
            var textB = b.label.toUpperCase();
          
            return textA.localeCompare(textB);
          }); */
        return this.Symbols;
    }

    getdataset() {
        return this.Dataset;
    }
    getsymbolsarray() {
        return this.SymbolsArray;
    }
    getrecordcount() {
        return this.recordcount;
    }
    setrecordcount(value:any) {
        this.recordcount = value;
    }

    getAdjustDateForTimeOffset(dateToAdjust: any) {
        let offsetMs = dateToAdjust.getTimezoneOffset() * 60000;
        return new Date(dateToAdjust.getTime() - offsetMs);
    }

    getMultiLegEventTypes() {
        let typeArr = this.UserService.getDropDownList('type') && this.UserService.getDropDownList('type').reduce((accumulator: string | any[], current: { value: any; }) => accumulator.concat(current.value), []);
        return typeArr && typeArr.filter((eventType: string) => eventType.startsWith("ML"));
    }

    getQuickFilterEventType(activeType: string) {
        let filteredEventTypes: any = [];
        let typeArr = this.UserService.getDropDownList('type').reduce((accumulator: string | any[], current: { value: any; }) => accumulator.concat(current.value), []);

        if (this.eventTypes.includes(activeType)) {
            if (activeType === 'Equities') {
                filteredEventTypes = typeArr.filter((eventType: string) => (eventType !== "MEPA" && eventType !== "MEAA" && eventType.startsWith("ME")));
            } else if (activeType === 'Options') {
                filteredEventTypes = typeArr.filter((eventType: string) => ((eventType.startsWith("MO") || eventType.startsWith("ML"))));
            } else if (activeType === 'Multi-Leg') {
                filteredEventTypes = typeArr.filter((eventType: string) => eventType.startsWith("ML"));
            } else if (activeType === 'Single-Leg') {
                filteredEventTypes = typeArr.filter((eventType: string) => eventType.startsWith("MO"));
            } else if (activeType === 'Allocations') {
                filteredEventTypes = typeArr.filter((eventType: string) => (eventType === "MEPA" || eventType === "MEAA"));
            } else if (activeType === 'Representative Orders') {
                filteredEventTypes = typeArr.filter((eventType: string) => (eventType === "MENO" || eventType === "MONO" || eventType === "MENOS" || eventType === "MONOS" || eventType === "MLNO" || eventType === "MLOS"));
            } else {
                filteredEventTypes = typeArr;
            }
        }

        return filteredEventTypes;
    }

    formatMultiDimensionalColumns(rowData:any, optedMultiDimensionalColumns:any) {
        const multiDimensionalFields = Object.keys(optedMultiDimensionalColumns);
        for(let j=0; j<multiDimensionalFields.length; j++) {
            let resultStr = '';
            if(rowData[multiDimensionalFields[j]]) {
                let multiDimensionalFieldArr: string[] = [];
                if(typeof rowData[multiDimensionalFields[j]] === 'object') {
                    rowData[multiDimensionalFields[j]] = JSON.parse(JSON.stringify(rowData[multiDimensionalFields[j]]));
                } else if (typeof rowData[multiDimensionalFields[j]] === 'string') {
                    rowData[multiDimensionalFields[j]] = JSON.parse(rowData[multiDimensionalFields[j]]);
                }
                let childArray:any[]=rowData[multiDimensionalFields[j]];
                if (typeof childArray !== 'undefined' && childArray.length > 0){ 
                childArray.forEach(multiDimensionalFieldObject => {
                    let elementArr : any[] = [];
                    for (let key = 0; key < optedMultiDimensionalColumns[multiDimensionalFields[j]].length; key++) {
                        elementArr.push(multiDimensionalFieldObject[optedMultiDimensionalColumns[multiDimensionalFields[j]][key]]);
                    }
                    multiDimensionalFieldArr.push(elementArr.join('@'));
                });
                }else{
                    resultStr = rowData[multiDimensionalFields[j]];
                }
                resultStr = multiDimensionalFieldArr.join('|');
            } else {
                resultStr = rowData[multiDimensionalFields[j]];
            }
            rowData[multiDimensionalFields[j]] = resultStr;
        }
        return rowData;
    }

    prepareQuickviewPanel(eventType: string) {
        let eventDetailsJSON: any = [];
        switch (eventType.toLocaleUpperCase()) {
            case 'MECO':
                eventDetailsJSON = CAT_MECO;
                break;
            case 'MECOC':
                eventDetailsJSON = CAT_MECOC;
                break;
            case 'MECOM':
                eventDetailsJSON = CAT_MECOM;
                break;
            case 'MEFA':
                eventDetailsJSON = CAT_MEFA;
                break;
            case 'MEIR':
                eventDetailsJSON = CAT_MEIR;
                break;
            case 'MENO':
                eventDetailsJSON = CAT_MENO;
                break;
            case 'MENOS':
                eventDetailsJSON = CAT_MENOS;
                break;
            case 'MENQ':
                eventDetailsJSON = CAT_MENQ;
                break;
            case 'MEOA':
                eventDetailsJSON = CAT_MEOA;
                break;
            case 'MEOC':
                eventDetailsJSON = CAT_MEOC;
                break;
            case 'MEOF':
                eventDetailsJSON = CAT_MEOF;
                break;
            case 'MEOJ':
                eventDetailsJSON = CAT_MEOJ;
                break;
            case 'MEOM':
                eventDetailsJSON = CAT_MEOM;
                break;
            case 'MEOMS':
                eventDetailsJSON = CAT_MEOMS;
                break;
            case 'MEOR':
                eventDetailsJSON = CAT_MEOR;
                break;
            case 'MEOT':
                eventDetailsJSON = CAT_MEOT;
                break;
            case 'MEOTS':
                eventDetailsJSON = CAT_MEOTS;
                break;
            case 'MEQC':
                eventDetailsJSON = CAT_MEQC;
                break;
            case 'MEQN':
                eventDetailsJSON = CAT_MEQN;
                break;
            case 'MEQR':
                eventDetailsJSON = CAT_MEQR;
                break;
            case 'MERQ':
                eventDetailsJSON = CAT_MERQ;
                break;
            case 'MEAA':
                eventDetailsJSON = CAT_MEAA;
                break;
            case 'MEIC':
                eventDetailsJSON = CAT_MEIC;
                break;
            case 'MEIM':
                eventDetailsJSON = CAT_MEIM;
                break;
            case 'MEOE':
                eventDetailsJSON = CAT_MEOE;
                break;
            case 'MEOFS':
                eventDetailsJSON = CAT_MEOFS;
                break;
            case 'MEORS':
                eventDetailsJSON = CAT_MEORS;
                break;
            case 'MEPA':
                eventDetailsJSON = CAT_MEPA;
                break;
            case 'MOCO':
                eventDetailsJSON = CAT_MOCO;
                break;
            case 'MOCOC':
                eventDetailsJSON = CAT_MOCOC;
                break;
            case 'MOCOM':
                eventDetailsJSON = CAT_MOCOM;
                break;
            case 'MOFA':
                eventDetailsJSON = CAT_MOFA;
                break;
            case 'MOPA':
                eventDetailsJSON = CAT_MOPA;
                break;
            case 'MOAA':
                eventDetailsJSON = CAT_MOAA;
                break;
            case 'MOIR':
                eventDetailsJSON = CAT_MOIR;
                break;
            case 'MONO':
                eventDetailsJSON = CAT_MONO;
                break;
            case 'MONOS':
                eventDetailsJSON = CAT_MONOS;
                break;
            case 'MONQ':
                eventDetailsJSON = CAT_MONQ;
                break;
            case 'MOOA':
                eventDetailsJSON = CAT_MOOA;
                break;
            case 'MOOC':
                eventDetailsJSON = CAT_MOOC;
                break;
            case 'MOOF':
                eventDetailsJSON = CAT_MOOF;
                break;
            case 'MOOFS':
                eventDetailsJSON = CAT_MOOFS;
                break;
            case 'MOOJ':
                eventDetailsJSON = CAT_MOOJ;
                break;
            case 'MOOM':
                eventDetailsJSON = CAT_MOOM;
                break;
            case 'MOOR':
                eventDetailsJSON = CAT_MOOR;
                break;
            case 'MOMR':
                eventDetailsJSON = CAT_MOMR;
                break;
            case 'MOCR':
                eventDetailsJSON = CAT_MOCR;
                break;
            case 'MOOE':
                eventDetailsJSON = CAT_MOOE;
                break;
            case 'MOOT':
                eventDetailsJSON = CAT_MOOT;
                break;
            case 'MOORS':
                eventDetailsJSON = CAT_MOORS;
                break;
            case 'MOIM':
                eventDetailsJSON = CAT_MOIM;
                break;
            case 'MOIC':
                eventDetailsJSON = CAT_MOIC;
                break;
            case 'MOQR':
                eventDetailsJSON = CAT_MOQR;
                break;
            case 'MORQ':
                eventDetailsJSON = CAT_MORQ;
                break;
            case 'MOIMR':
                eventDetailsJSON = CAT_MOIMR;
                break;
            case 'MOICR':
                eventDetailsJSON = CAT_MOICR;
                break;
            case 'MOOMS':
                eventDetailsJSON = CAT_MOOMS;
                break;
            case 'MOOMR':
                eventDetailsJSON = CAT_MOOMR;
                break;
            case 'MOOCR':
                eventDetailsJSON = CAT_MOOCR;
                break;
            case 'MOMRS':
                eventDetailsJSON = CAT_MOMRS;
                break;
            case 'MOCRS':
                eventDetailsJSON = CAT_MOCRS;
                break;
            case 'MEMR':
                eventDetailsJSON = CAT_MEMR;
                break;
            case 'MECR':
                eventDetailsJSON = CAT_MECR;
                break;
            case 'MEIMR':
                eventDetailsJSON = CAT_MEIMR;
                break;
            case 'MEICR':
                eventDetailsJSON = CAT_MEICR;
                break;
            case 'MEOMR':
                eventDetailsJSON = CAT_MEOMR;
                break;
            case 'MEOCR':
                eventDetailsJSON = CAT_MEOCR;
                break;
            case 'MEMRS':
                eventDetailsJSON = CAT_MEMRS;
                break;
            case 'MECRS':
                eventDetailsJSON = CAT_MECRS;
                break;
            case 'MLNO':
                eventDetailsJSON = CAT_MLNO;
                break;
            case 'MLNQ':
                eventDetailsJSON = CAT_MLNQ;
                break;
            case 'MLOR':
                eventDetailsJSON = CAT_MLOR;
                break;
            case 'MLMR':
                eventDetailsJSON = CAT_MLMR;
                break;
            case 'MLCR':
                eventDetailsJSON = CAT_MLCR;
                break;
            case 'MLOA':
                eventDetailsJSON = CAT_MLOA;
                break;
            case 'MLIR':
                eventDetailsJSON = CAT_MLIR;
                break;
            case 'MLIM':
                eventDetailsJSON = CAT_MLIM;
                break;
            case 'MLIC':
                eventDetailsJSON = CAT_MLIC;
                break;
            case 'MLIMR':
                eventDetailsJSON = CAT_MLIMR;
                break;
            case 'MLICR':
                eventDetailsJSON = CAT_MLICR;
                break;
            case 'MLCO':
                eventDetailsJSON = CAT_MLCO;
                break;
            case 'MLCOM':
                eventDetailsJSON = CAT_MLCOM;
                break;
            case 'MLCOC':
                eventDetailsJSON = CAT_MLCOC;
                break;
            case 'MLOM':
                eventDetailsJSON = CAT_MLOM;
                break;
            case 'MLOMR':
                eventDetailsJSON = CAT_MLOMR;
                break;
            case 'MLOC':
                eventDetailsJSON = CAT_MLOC;
                break;
            case 'MLOCR':
                eventDetailsJSON = CAT_MLOCR;
                break;
            case 'MLOS':
                eventDetailsJSON = CAT_MLOS;
                break;
            case 'MLQR':
                eventDetailsJSON = CAT_MLQR;
                break;
            case 'MLRQ':
                eventDetailsJSON = CAT_MLRQ;
                break;
            case 'MLOE':
                eventDetailsJSON = CAT_MLOE;
                break;
    
            default: {
                break;
            }
        }
        return eventDetailsJSON;
    }

    handleNoRecordsPageNumber(totalRecords : number) {
        if(totalRecords == 0){
          totalRecords = 1;
        }
        return totalRecords;
      }

    // Start of Quick search functionality
    quickSearchByValues(DefaultFilterArray: any, payload: any) {
        let keyArr = Object.keys(payload);
        DefaultFilterArray.map((item: any) => {
            if (keyArr.indexOf(item.columnname) >= 0 && payload[item.columnname] != undefined) {
                if (['skip', 'array', 'daterange'].includes(item.datatype.toLowerCase())) {
                    item.values = payload[item.columnname];
                } else {
                    item.filterby = "IS";
                    item.values = payload[item.columnname].trim();
                    if (item.values.indexOf(",") >= 0) {
                        item.filterby = "IN";
                    } else if (item.values.indexOf("%") >= 0) {
                        item.filterby = "LIKE";
                    }
                }
            }
        });
    }
    
    clearQuickSearch(DefaultFilterArray: any, defaultFilterValues: any) {
        DefaultFilterArray.map((item: any) => {
            if (defaultFilterValues && defaultFilterValues[item.columnname]) {
                item.values = defaultFilterValues[item.columnname];
                item.filterby = "IS";
            } else if (['string', 'char'].includes(item.datatype.toLowerCase())) {
                item.values = "";
                item.filterby = "IS";
            } else if(['int', 'number', 'float'].includes(item.datatype.toLowerCase())){
                item.values = "";
                item.filterby = "=";
            } else if(['skip', 'array'].includes(item.datatype.toLowerCase()) && (item.module && !['cais'].includes(item.module.toLowerCase()))) {
                item.values = [];
                item.filterby = "IN";
            }
        });
    }      
    // End of Quick search functionality
}